import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const logisticsTypeEnum = createEnum({
    DOMESTIC: ['domestic', '国内物流', 'blue'],
    INTERNATIONAL: ['international', '国际物流', 'green'],
});
export const LOGISTICS_TYPES = enumValues(logisticsTypeEnum);
export const LOGISTICS_TYPE_LABEL_MAP = enumLabelMap(logisticsTypeEnum);
export const logisticsStatusEnum = createEnum({
    PENDING: ['pending', '待运输', 'default'],
    IN_TRANSIT: ['in_transit', '运输中', 'processing'],
    ARRIVED: ['arrived', '已送达', 'success'],
    EXCEPTION: ['exception', '异常', 'error'],
});
export const LOGISTICS_STATUSES = enumValues(logisticsStatusEnum);
export const LOGISTICS_STATUS_LABEL_MAP = enumLabelMap(logisticsStatusEnum);
export const logisticsTransportModeEnum = createEnum({
    ROAD: ['road', '公路运输', 'blue'],
    RAIL: ['rail', '铁路运输', 'cyan'],
    SHORT_HAUL: ['short_haul', '短驳运输', 'orange'],
    RO_RO: ['ro_ro', '滚装船', 'purple'],
    CONTAINER: ['container', '集装箱', 'geekblue'],
    BREAK_BULK: ['break_bulk', '散杂船', 'gold'],
    LAND: ['land', '陆运', 'green'],
});
export const LOGISTICS_TRANSPORT_MODES = enumValues(logisticsTransportModeEnum);
export const LOGISTICS_TRANSPORT_MODE_LABEL_MAP = enumLabelMap(logisticsTransportModeEnum);
export const logisticsAttachmentTypeEnum = createEnum({
    LOGISTICS_CONTRACT: ['logistics_contract', '物流合同附件', 'blue'],
    LOGISTICS_INVOICE: ['logistics_invoice', '物流发票附件', 'cyan'],
    TRANSPORT_ORDER: ['transport_order', '运输单附件', 'green'],
    INSPECTION_MEDIA: ['inspection_media', '验车照片或视频', 'gold'],
});
export const LOGISTICS_ATTACHMENT_TYPES = enumValues(logisticsAttachmentTypeEnum);
export const LOGISTICS_ATTACHMENT_TYPE_LABEL_MAP = enumLabelMap(logisticsAttachmentTypeEnum);
export const domesticLogisticsTransportModes = [
    logisticsTransportModeEnum.ROAD,
    logisticsTransportModeEnum.RAIL,
    logisticsTransportModeEnum.SHORT_HAUL,
];
export const internationalLogisticsTransportModes = [
    logisticsTransportModeEnum.RO_RO,
    logisticsTransportModeEnum.CONTAINER,
    logisticsTransportModeEnum.BREAK_BULK,
    logisticsTransportModeEnum.LAND,
];
//# sourceMappingURL=logistics.js.map